import { render, staticRenderFns } from "./Lote.vue?vue&type=template&id=2a4f4f62&"
import script from "./Lote.vue?vue&type=script&lang=js&"
export * from "./Lote.vue?vue&type=script&lang=js&"
import style0 from "./Lote.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports